import {
  useGetNotificationChannelsForCurrentAccountQuery,
  useGetNotificationChannelsForCurrentAccountLazyQuery,
  NotificationScopeTypeEnum,
} from '../../../../api'

export const usePlatformNotificationChannels = () => {
  const { data, loading, error } = useGetNotificationChannelsForCurrentAccountQuery({
    variables: {
      scopeType: NotificationScopeTypeEnum.Global,
    },
    fetchPolicy: 'no-cache',
  })

  return {
    data,
    loading,
    error,
  }
}

export const usePartnerNotificationChannels = (partnerId?: string) => {
  const { data, loading, error } = useGetNotificationChannelsForCurrentAccountQuery({
    variables: {
      scopeType: NotificationScopeTypeEnum.Partner,
      scopeId: partnerId,
    },
    fetchPolicy: 'no-cache',
    skip: !partnerId,
  })

  return {
    data,
    loading,
    error,
  }
}

export const useBannerNotificationChannels = (bannerId?: string) => {
  const { data, loading, error } = useGetNotificationChannelsForCurrentAccountQuery({
    variables: {
      scopeType: NotificationScopeTypeEnum.Banner,
      scopeId: bannerId,
    },
    fetchPolicy: 'no-cache',
    skip: !bannerId,
  })

  return {
    data,
    loading,
    error,
  }
}
